// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disabledAdequate {
  pointer-events: none;
  opacity: 0.4;
}

.buttonmd-secondary {
  background-color: #f6f6ff !important;
}

.border-dark {
  border-right: 4px solid #c0392b !important;
}

.color-text1 {
  color: #c0392b !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/csv-file-list/csv-file-list/csv-file-list.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,YAAA;AACF;;AACA;EACE,oCAAA;AAEF;;AAAA;EACE,0CAAA;AAGF;;AADA;EACE,yBAAA;AAIF","sourcesContent":[".disabledAdequate {\n  pointer-events: none; //This makes it not clickable\n  opacity: 0.4; //This grays it out to look disabled\n}\n.buttonmd-secondary {\n  background-color: #f6f6ff !important;\n}\n.border-dark {\n  border-right: 4px solid #c0392b !important;\n}\n.color-text1 {\n  color: #c0392b !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
